import React, { InputHTMLAttributes } from "react";

interface RadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  value: string;
  name: string;
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// TODO Integrate with forms library
export default function Radio({
  id,
  label,
  value,
  name,
  checked,
  onChange,
  ...rest
}: RadioButtonProps) {
  return (
    <label
      htmlFor={id}
      className={`group flex flex-auto gap-3 rounded-full h-14 px-3 items-center hover:ring-2 hover:ring-brand shadow-leap ${
        checked ? "ring-2 ring-brand" : ""
      }`}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        {...rest}
        className="appearance-none flex-none w-6 h-6 rounded-full border-2 border-font group-hover:border-brand before:block before:w-3/5 before:h-3/5 before:rounded-full before:my-1 before:mx-auto checked:border-brand checked:before:bg-brand"
      />
      <span className="text-novartis-font">{label}</span>
    </label>
  );
}
